import { module } from 'modujs';
window.nouislider = require('nouislider');

export default class extends module {
    constructor(m) {
        super(m);

        let start = parseInt(this.el.dataset.start);
        let stop = this.el.dataset.stop;
        let startArg = stop ? [start,stop] : [start];
        this.preview = this.$( 'preview' )[0];


        this.slider = nouislider.create( this.$( 'slider' )[0], {
            start: startArg,
            step: 1,
            range: {
                'min': [parseInt( this.el.dataset.min )],
                'max': [parseInt( this.el.dataset.max )]
            }
        });

        this.slider.on('update',  (values, handle) => {
            this.preview.textContent = values.map(item => parseFloat(item).toString()).join( '-');
        })

    }
    init() {}
    destroy(){}
}
